import {Sprite} from 'pixi.js';
import {Context} from '@gongxigames/framework/core/fragments/BuilderX/types';
import {Animation} from '@gongxigames/framework/core/fragments/display';
import {Component, ComponentProps, TweenConfig} from './Component';

export type TweenAnimationProps = ComponentProps & {
    repeat?: number|string;
    tweens?: TweenConfig[];
};

export class TweenAnimation extends Component<TweenAnimationProps, Animation> {
    public readonly jsxType: string = 'tween_animation';

    public clone(): TweenAnimation {
        return new TweenAnimation(this.props);
    }

    public getConstructor(): new () => any {
        return Animation;
    }

    public getChildrenToPixi(): Component<ComponentProps>[] {
        return [];
    }

    public updateProps(context: Context, container: Sprite, element: Animation): void {
        const {tweens} = this.props;

        if (tweens) {
            this.createTweenAnimation(container, element, tweens);
        }

        super.updateProps(context, container, element);
    }
}
